import './Piggy.component.scss';

import React from 'react';
import { FormattedMessage } from 'react-intl';

import { formatNumberToCurrency } from '../../../utils/FormNormalizers';
import { getAssetUrl } from '../../../utils/GetAssetUrl';

function IsBrokenBanner() {
  return (
    <div className='is-broken-banner d-flex justify-content-center align-items-center'>
      <div className='text'>
        <FormattedMessage id='atoms.piggy.broken' />
      </div>
    </div>
  );
}

export function PiggyComponent(props: { amount: number; isBroken?: boolean }) {
  const { amount, isBroken } = props;
  return (
    <div className='total-amount-container mx-auto'>
      <div className='coin-container'>
        <h5>{formatNumberToCurrency(amount)}</h5>
      </div>
      <div className='piggy-container'>
        <div
          style={{
            backgroundImage: `url(${getAssetUrl.icons('CERDITO.svg')})`,
          }}
        />
      </div>
      {!amount && (
        <p className='mt-3 text-primary'>
          <FormattedMessage id='common.no-money' />
        </p>
      )}
      {isBroken && (<IsBrokenBanner />)}
    </div>
  );
}
